var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailnotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 149,
    viewBox: "0 0 151 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.83 100.421H50.2842V124.284H104.83V100.421Z",
    fill: "#E4E4E5",
    stroke: "#868995"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70459 100.988L12.6826 69.284C13.7726 66.1363 15.9769 63.4965 18.8797 61.8626L28.0317 56.7113L19.7127 100.988H1.70459Z",
    fill: "#E4E4E5",
    stroke: "#868995"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.054 100.988L138.076 69.284C136.986 66.1363 134.782 63.4965 131.879 61.8626L122.727 56.7113L131.046 100.988H149.054Z",
    fill: "#E4E4E5",
    stroke: "#868995"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6571 0.70459H110.073L128.403 19.3348C124.766 53.4984 128.942 81.6966 140.931 103.93C134.715 103.93 121.069 103.93 99.9916 103.93H51.9058C31.2081 103.93 16.747 103.93 8.52271 103.93C18.7644 88.9704 22.2421 55.1657 18.9558 2.51534L18.9558 2.51534C18.8972 1.57577 19.6113 0.766547 20.5509 0.707901C20.5862 0.705694 20.6216 0.70459 20.6571 0.70459Z",
    fill: "white",
    stroke: "#868995"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.25 23.2898V37.3523C56.25 39.4705 57.9671 41.1875 60.0852 41.1875H83.0966C85.2148 41.1875 86.9318 39.4705 86.9318 37.3523V23.2898C86.9318 21.1717 85.2148 19.4546 83.0966 19.4546H60.0852C57.9671 19.4546 56.25 21.1717 56.25 23.2898ZM81.0384 28.3012L72.0895 32.1364C71.7671 32.275 71.402 32.275 71.0795 32.1364L62.1307 28.3012C61.4811 28.0223 61.1806 27.2696 61.4595 26.6201C61.7384 25.9705 62.4911 25.67 63.1406 25.9489L71.0795 29.3495C71.402 29.4881 71.7671 29.4881 72.0895 29.3495L80.0284 25.9489C80.678 25.67 81.4306 25.9705 81.7095 26.6201C81.9885 27.2696 81.6879 28.0223 81.0384 28.3012Z",
    fill: "#868995"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9092 83.0554H109.091",
    stroke: "#F2F2F2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9092 66.6492H66.4774",
    stroke: "#F2F2F2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5227 66.6492H109.091",
    stroke: "#F2F2F2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70459 101.273H49.9768C50.9182 101.273 51.6813 102.036 51.6813 102.977V111.115C51.6813 113.939 53.9708 116.228 56.795 116.228H91.6809C94.5051 116.228 96.7946 113.939 96.7946 111.115V102.977C96.7946 102.036 97.5577 101.273 98.4991 101.273H149.462L132.26 143.687C131.217 146.26 128.718 147.943 125.942 147.943H23.1656C20.2835 147.943 17.7127 146.131 16.744 143.416L1.70459 101.273Z",
    fill: "white",
    stroke: "#868995"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0796 148.148H135.511",
    stroke: "#868995",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.943 1.55688V18.6023",
    stroke: "#868995",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.943 18.6023H126.989",
    stroke: "#868995",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.463 19.4546C126.22 38.535 126.439 53.8893 128.121 65.5177C129.803 77.146 133.067 88.7414 137.915 100.304H133.099C128.462 91.256 125.278 81.2655 123.546 70.3325C121.814 59.3995 121.35 42.4402 122.152 19.4546H127.463Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9888 110.648H96.307",
    stroke: "#868995",
    strokeLinecap: "square"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4423 101.945C50.9955 105.052 50.4423 109.615 50.9955 112.305C51.7578 114.103 52.5968 115.357 53.5125 116.065L51.606 116.178C48.7867 116.344 46.3665 114.193 46.2003 111.374C46.1944 111.274 46.1914 111.173 46.1914 111.073V101.945C47.4318 101.945 48.8488 101.945 50.4423 101.945Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M137.75 102.298H148.282L131.305 144.216C130.523 146.146 128.648 147.41 126.565 147.41H120.924L137.75 102.298Z",
    fill: "#E4E4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailnotfound);
export default __webpack_public_path__ + "static/media/emailnotfound.d36b3d7a.svg";
export { ForwardRef as ReactComponent };